import React, { useState } from 'react'
import { CollateralAllocation, CollateralAllocationDetail } from 'api'
import { Heading, SearchBar, ScrollContainer, NoEntities, AvailableTable } from '../allocationDialogStyles'
import { TextButtonType } from 'view/components/buttons'
import { SelectButton } from 'view/components/options/optionsStyles'
import { Locale, Translation } from 'locale'

interface ProductsPanelProps {
  allocationDetails: CollateralAllocationDetail[]
  onCollateralAllocationChange: (
    originalCollateralAllocation: CollateralAllocation | undefined,
    partialUpdatedCollateralAllocation: Partial<CollateralAllocation> | undefined
  ) => void
}

export const AvailableProductsPanel: React.FunctionComponent<ProductsPanelProps> = props => {
  const { allocationDetails, onCollateralAllocationChange } = props
  const [search, setSearch] = useState('')

  const filteredAllocationDetails = allocationDetails.filter(
    allocationDetail =>
      allocationDetail.collateral.id.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
      allocationDetail.collateral.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
      allocationDetail.collateral.isin?.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  )

  return (
    <>
      <Heading>
        {Locale.translate(Translation.SC_AVAILABLE_PRODUCTS_TO_ALLOCATE)} ({allocationDetails.length}):
      </Heading>
      <SearchBar
        dataTestId={'AvailableProductsPanel-ProductsSearchBar'}
        value={search}
        onUpdate={value => setSearch(value)}
        placeholder={Locale.translate(Translation.SC_SEARCH_COLLATERALS)}
        onPaste={e => e.stopPropagation()}
      />
      <ScrollContainer maxHeight={400}>
        <AvailableTable>
          <thead>
            <tr>
              <th style={{ width: 120 }}>{Locale.translate(Translation.TC_ISIN_CUSIP)}</th>
              <th colSpan={2}>{Locale.translate(Translation.TC_COLLATERAL)}</th>
            </tr>
          </thead>
          {filteredAllocationDetails.length > 0 && (
            <tbody>
              {filteredAllocationDetails.map(allocationDetail => {
                const {
                  collateral: { name, id },
                  collateralAllocation: { canTrade }
                } = allocationDetail

                const onAllocationChange = () => {
                  onCollateralAllocationChange(undefined, { ...allocationDetail.collateralAllocation, selected: true })
                }

                return (
                  <tr key={id}>
                    <td>{id}</td>
                    <td>{name}</td>
                    <td style={{ width: 65 }}>
                      <SelectButton
                        dataTestId={'AvailableProductsPanel-SelectButton-AddButton'}
                        selected={true}
                        disabled={!canTrade}
                        type={TextButtonType.Primary}
                        onClick={() => onAllocationChange()}>
                        {Locale.translate(Translation.TC_BUTTON_ADD)}
                      </SelectButton>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          )}
        </AvailableTable>
        {filteredAllocationDetails.length === 0 && <NoEntities>{Locale.translate(Translation.SC_NO_COLLATERALS_FOUND)}</NoEntities>}
      </ScrollContainer>
    </>
  )
}
